import React, { ChangeEvent, useContext, useState } from 'react';
import { SearchField, useGetWorkshifts } from '../../../../common';
import { AppContext } from '../../../../common/context/';
import { BaseConfirmModal } from '../../modals/BaseConfirmModal';
import { Props } from './selectWorkshiftTypeProps';

const SelectWorkshiftType = ({
    isOpenModal,
    modalTitle,
    showControls,
    onClose,
    onSubmit,
}: Props) => {
    const {
        langResources,
        isSkinSmart,
        workshiftList,
        workshiftListCopy,
        setWorkshiftListCopy,
        isLoadingDataList,
    } = useContext(AppContext);

    const [searchTerm, setSearchTerm] = useState('');
    const [workshiftSelected, setWorkshiftSelected] = useState<number>(-1);
    const [isCollapse, setIsCollapse] = useState(false);

    const { workshiftDetails, isLoadingDataDetails, setIsLoadingData } =
        useGetWorkshifts(workshiftSelected);

    const handlerSubmit = () => {
        onClose();
        onSubmit(!workshiftSelected ? null : workshiftSelected);
    };

    const handlerChangeTypeWorkshift = (e: ChangeEvent<HTMLInputElement>) => {
        let nameOfWorkshift = e.target.value;

        setSearchTerm(nameOfWorkshift);

        const workshiftFiltered = workshiftList?.filter((w) =>
            w.name.toLowerCase().includes(nameOfWorkshift.toLowerCase())
        );

        setWorkshiftListCopy(workshiftFiltered);
    };

    const handleResetSearchTerm = () => {
        setSearchTerm('');
        setWorkshiftListCopy(workshiftList);
    };

    const handlerSelectWorkshift = (id: number) => {
        setWorkshiftSelected(id);
    };

    return (
        <BaseConfirmModal
            isLoading={false}
            isOpen={isOpenModal}
            isShowControls={showControls}
            modalTitle={modalTitle}
            onClose={onClose}
            onSubmit={handlerSubmit}
            textButton={langResources['reports.generate.report.button']}
            customMaxWidth={900}
        >
            <div
                className='modal-body py-0'
                style={{ paddingBottom: 0, minHeight: 420 }}
            >
                <div className='row mb-1'>
                    <h5 className='text-muted '>
                        {
                            langResources[
                                'filter.modal.select.workshift.type.alert.msg'
                            ]
                        }
                    </h5>
                </div>

                <div className='row'>
                    {!isLoadingDataList ? (
                        <div className='col-3'>
                            <SearchField
                                dataListId=''
                                selectItemId={handlerChangeTypeWorkshift}
                                inputPlaceholder={
                                    langResources['create.workshift.Modal'][
                                        'select.workshift.placeholder'
                                    ]
                                }
                                labelTitle={''}
                                searchTerm={searchTerm}
                                handleResetSearchTerm={handleResetSearchTerm}
                            />

                            <div
                                className='mb-3'
                                style={{
                                    maxHeight: 350,
                                    minHeight: 200,
                                    overflowY: 'scroll',
                                }}
                            >
                                <ul className='list-group list-group-flush'>
                                    {workshiftListCopy?.map((w) => (
                                        <li
                                            onClick={() =>
                                                handlerSelectWorkshift(w.id)
                                            }
                                            className={`list-group-item p-1 text-selected ${
                                                workshiftSelected === w.id &&
                                                'text-selected--active'
                                            }`}
                                            key={w.id}
                                            title={w.name}
                                        >
                                            {w.name}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    ) : (
                        <div className='col-3'>
                            <h5 className='card-title placeholder-glow'>
                                <span className='placeholder col-6'></span>
                            </h5>

                            <p className='card-text placeholder-glow'>
                                <span className='placeholder col-12 bg-dark'></span>
                            </p>

                            <p className='card-text placeholder-glow'>
                                <span className='placeholder col-7 bg-dark'></span>
                            </p>

                            <p className='card-text placeholder-glow'>
                                <span className='placeholder col-12 bg-dark'></span>
                            </p>

                            <p className='card-text placeholder-glow'>
                                <span className='placeholder col-7 bg-dark'></span>
                                <span className='placeholder col-4 bg-dark'></span>
                                <span className='placeholder col-4 bg-dark'></span>
                                <span className='placeholder col-4 bg-dark'></span>
                                <span className='placeholder col-4 bg-dark'></span>
                            </p>

                            <p className='card-text placeholder-glow'>
                                <span className='placeholder col-7 bg-dark'></span>
                                <span className='placeholder col-4 bg-dark'></span>
                                <span className='placeholder col-4 bg-dark'></span>
                                <span className='placeholder col-4 bg-dark'></span>
                                <span className='placeholder col-4 bg-dark'></span>
                            </p>
                        </div>
                    )}

                    <div className='col-9'>
                        <div className='row'>
                            <div className='col-12'>
                                <h5 className={`text-primary2`}>
                                    {
                                        langResources['create.workshift.Modal'][
                                            'details.title'
                                        ]
                                    }
                                </h5>
                            </div>

                            <div className='col-6'>
                                <p>
                                    {
                                        langResources['create.workshift.Modal'][
                                            'workshift.name'
                                        ]
                                    }
                                    :<br />
                                    {workshiftDetails?.name}
                                </p>
                                <p style={{ marginTop: '-10px' }}>
                                    {
                                        langResources['create.workshift.Modal'][
                                            'double.title'
                                        ]
                                    }
                                    :
                                    {workshiftDetails?.isDuplex
                                        ? langResources['msg.yes']
                                        : langResources['msg.no']}
                                </p>

                                <p style={{ marginTop: '-15px' }}>
                                    ¿Turno Continuo?:{' '}
                                    {workshiftDetails?.isNextTurn
                                        ? langResources['msg.yes']
                                        : langResources['msg.no']}
                                </p>

                                <p style={{ marginTop: '-15px' }}>
                                    ¿Solo Extra?:{' '}
                                    {workshiftDetails?.isExtra
                                        ? langResources['msg.yes']
                                        : langResources['msg.no']}
                                </p>

                                {workshiftDetails?.isAutomaticDiscount && (
                                    <p style={{ marginTop: '-15px' }}>
                                        Descuento Automatico:{' '}
                                        {
                                            workshiftDetails.timeAutomaticDiscount.split(
                                                'T'
                                            )[1]
                                        }
                                    </p>
                                )}
                            </div>
                        </div>

                        <div className='row'>
                            <table className='table position-relative'>
                                <thead className='text-dark'>
                                    <tr>
                                        <th scope='col' className='p-2 px-3'>
                                            {
                                                langResources[
                                                    'create.workshift.Modal'
                                                ]['day']
                                            }
                                        </th>
                                        {workshiftDetails?.isDuplex ? (
                                            <>
                                                <th scope='col' className='p-2 px-3'>
                                                    {
                                                        langResources[
                                                            'create.workshift.Modal'
                                                        ]['scheduling1']
                                                    }
                                                </th>
                                                <th scope='col' className='p-2 px-3'>
                                                    {
                                                        langResources[
                                                            'create.workshift.Modal'
                                                        ]['scheduling2']
                                                    }
                                                </th>
                                            </>
                                        ) : (
                                            <>
                                                <th scope='col' className='p-2 px-3'>
                                                    {
                                                        langResources[
                                                            'create.workshift.Modal'
                                                        ]['entry']
                                                    }
                                                </th>
                                                <th scope='col' className='p-2 px-3'>
                                                    {
                                                        langResources[
                                                            'create.workshift.Modal'
                                                        ]['exit']
                                                    }
                                                </th>
                                            </>
                                        )}

                                         <th scope='col' className='p-2 px-3'>
                                            {
                                                langResources[
                                                    'create.workshift.Modal'
                                                ]['isNextTurn']
                                            }
                                        </th>


                                    </tr>
                                </thead>

                                <span
                                    className='position-absolute text-muted fs-3 btn btn-small border-0'
                                    style={{ right: 0, top: 0 }}
                                    onClick={() => setIsCollapse(!isCollapse)}
                                >
                                    <i
                                        className={
                                            isCollapse
                                                ? 'ri-arrow-drop-up-line'
                                                : 'ri-arrow-drop-down-line'
                                        }
                                    ></i>
                                </span>

                                {isCollapse && (
                                    <tbody>
                                        {workshiftDetails?.workshiftsDayList.map(
                                            (turnFix) => (
                                                <tr
                                                    key={turnFix.name}
                                                    className='text-muted'
                                                >
                                                    <th className='p-1 px-3'>
                                                        {turnFix.name}
                                                    </th>
                                                    {workshiftDetails.isDuplex ? (
                                                        <>
                                                            <th className='p-1 px-3'>
                                                                {turnFix.checkInTime}{' '}
                                                                -{' '}
                                                                {
                                                                    turnFix.departureTime
                                                                }
                                                            </th>
                                                            <th className='p-1 px-3'>
                                                                {
                                                                    turnFix.checkInTime2
                                                                }{' '}
                                                                -{' '}
                                                                {
                                                                    turnFix.departureTime2
                                                                }
                                                            </th>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <th className='p-1 px-3'>
                                                                {turnFix.checkInTime}
                                                            </th>
                                                            <th className='p-1 px-3'>
                                                                {
                                                                    turnFix.departureTime2
                                                                }
                                                            </th>
                                                        </>
                                                    )}

                                                    <th className='p-1 px-3'>
                                                        {turnFix.isNextDay}
                                                    </th>
                                                </tr>
                                            )
                                        )}
                                    </tbody>
                                )}
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </BaseConfirmModal>
    );
};

export default SelectWorkshiftType;
